import { KYMW9009Model } from '../kymw9009.model';
import { UserClassManagementModel } from '../vo/user-class-management.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessViewUtils } from 'src/app/shared/utils/pless-view-utils.service';

/**
 * ユーザ階層管理更新コマンド
 * サーバーにユーザ階層管理更新をリクエストする。
 *
 * @export UpdateUserClassManagementService
 * @class UpdateUserClassManagementService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateUserClassManagementService extends PlessJsonResponderSub<any> {
  private model: KYMW9009Model = null;
  private voList: Array<UserClassManagementModel> = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateUserClassManagementService
   */
  private getBody(): PlessRequest {
    const request = {
      update: {
        UpdateUserClassManagementList: {
          combination: []
        }
      }
    };
    this.voList.forEach((model) => {
      const vo: any = new Object();
      vo.parameter = {
        ClassCode: model.ClassCode,
        BeforeGroupLeaderUserId: model.GroupUserIdOrigin,
        GroupLeaderUserId:       (model.GroupUserCheck) ? model.GroupUserId : model.GroupUserIdOrigin,
        BeforeStaffUserId:       model.StaffUserIdOrigin,
        StaffUserId:             (model.StaffUserCheck) ? model.StaffUserId : model.StaffUserIdOrigin,
        BeforeAgentUserId:       model.AgentUserIdOrigin,
        AgentUserId:             (model.AgentUserCheck) ? model.AgentUserId : model.AgentUserIdOrigin
      };
      request.update.UpdateUserClassManagementList.combination.push(vo);
    });
    return new PlessRequest(request);
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9009Model} model モデルクラス
   * @param {Array<UserClassManagementModel>} voList ユーザ階層管理VOリスト（送信対象に限定済み）
   * @memberof UpdateUserClassManagementService
   */
  execute(model: KYMW9009Model, voList: Array<UserClassManagementModel>) {
    this.model = model;
    this.voList = voList;
    this.send('updateUserClassManagement', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateUserClassManagementService
   */
  success(data: any) {
    // 更新リクエスト成功時処理
    this.model.updateUserClassUpdateSuccess();
  }

  /**
   * 業務エラー時のメソッド
   * @param {*} data レスポンスデータ
   */
  plessErrorHandler(data: any): void {
    
    if (data.errorcode !== 'E0570' &&
        data.errorcode !== 'E0580' &&
        data.errorcode !== 'E0581') {
      super.plessErrorHandler(data);
      return;
    }
    if (PlessViewUtils.isEmpty(data.strings) || data.strings < 3) {
      super.plessErrorHandler(data);
      return;
    }
    // 更新リクエスト失敗時処理
    this.model.updateUserClassUpdateFailure(this.voList, data.errorcode, data.strings);
  }
}
